<template>
  <section class="bg-green">
    <div class="l-content">
      <div :class="['quote','row', {lightbg}]">
        <div class="col-xs-14 col-xs-offset-2 col-sm-2 col-sm-offset-2">
          <div class="quote__author-box">
            <div class="quote__author-img">
              <img class="quote__img" :src="photo" alt="">
            </div>
            <div class="quote__author-text">
              <div class="name">{{name}}</div>
              <div class="quote__hr"></div>
              <div class="title" v-html="title"></div>
              <div v-if="company" class="title" v-html="company"></div>
            </div>
          </div>
        </div>
        <div class="col-xs-14 col-xs-offset-2 col-sm-11 col-sm-offset-1">
          <blockquote><slot/></blockquote>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: 'Quote',
  props: {
    photo: String,
    name: String,
    title: String,
    company: String,
    lightbg: {
      type: Boolean,
      required: false,
      default: false
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../scss/vars';
@import '../scss/mixins';
.quote {
  color: $white;
  text-align: left;
  padding-top: 80px;
  padding-bottom: 80px;
  &.lightbg {
    color: inherit;
  }
  &__img {
    // width: 100%;
    max-width: 74px;
    // height: 86px;
    display: block;
    border-radius: 4px;
    margin-right: 20px;
    @media (min-width: 768px) {
      width: 100%;
      max-width: 145px;
      // height: 136px;
    }
    img {
      width: 100%;
      display: block;
    }
  }
  &__author-box {
    display: flex;
    flex-flow: row;
    @media (min-width: 768px) {
      flex-flow: column;
    }
  }
  &__hr {
    width: 36px;
    height: 2px;
    background: $white;
    margin-bottom: 10px;
  }
  .name {
    font-size: px2rem(15);
    letter-spacing: 0.012em;
    margin-top: 0;
    margin-bottom: 12px;
    line-height: 1em;
    @media (min-width: 768px) {
      line-height: px2rem(23);
      margin-top: 20px;
      margin-bottom: 20px;
    }
  }
  .title {
    font-weight: 500;
    font-size: px2rem(13);
    line-height: px2rem(20);
    letter-spacing: 0.02em;
  }
  blockquote {
    margin: 0;
    padding-top: 90px;
    position: relative;
    font-size: px2rem(22);
    line-height: px2rem(35);
    letter-spacing: 0.02em;
    @media (min-width: 768px) {
      padding-top: 65px;
    }
    &:before {
      content: '“';
      font-size: px2rem(120);
      position: absolute;
      top: 30px;
      left: -6px;
      line-height: 100px;
      opacity: .3;
      color: $darker-grey;
      @media (min-width: 768px) {
        left: -6px;
        top: 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Quote.vue